import { render, staticRenderFns } from "./Paths.vue?vue&type=template&id=962baa72&scoped=true&"
import script from "./Paths.vue?vue&type=script&lang=js&"
export * from "./Paths.vue?vue&type=script&lang=js&"
import style0 from "./Paths.vue?vue&type=style&index=0&id=962baa72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962baa72",
  null
  
)

export default component.exports